import styled from "styled-components";

const Block = styled.div`
  font-family: #111;
  color: #124;
`;

export default Block;
